import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MainComponent } from './main/main.component';
import { LayoutModule } from './main/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { MainRoutingModule } from "./main/main-routing.module";
import { AuthModule } from "./auth/auth.module";
import { AppService } from './app.service';
import { ApiService } from './main/pages/api-service.service';
import { PagingService } from './_services/pagination.service';
import { FormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { ToasterModule, ToasterService } from 'angular5-toaster';
import { ExcelService } from './_services/excel.service';
@NgModule({
    declarations: [
        MainComponent,
        AppComponent,
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MainRoutingModule,
        AuthModule,
        FormsModule,
        MyDatePickerModule,
        ToasterModule

    ],
    providers: [ScriptLoaderService, AppService, ApiService, PagingService,ExcelService, ToasterService],
    bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/app.module.ts